import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import BlockIcon from "@mui/icons-material/Block";
import { ReactNode } from "react";

interface BlockButtonProps {
    loading: boolean;
    disabled?: boolean;
    onClick: () => void;
    label?: ReactNode
}

export const BlockButton: React.FC<BlockButtonProps> = ({ loading, disabled = false, onClick, label }) => {
    return (
        <LoadingButton
            loading={loading}
            disabled={disabled}
            size="small"
            color="error"
            variant="contained"
            startIcon={<BlockIcon />}
            onClick={onClick}
        >
            {label ? label : <Localized id="block">Zablokuj</Localized>}
        </LoadingButton>
    );
};
